import { render, staticRenderFns } from "./vAllergenMLModal.vue?vue&type=template&id=4d3301a6&scoped=true"
import script from "./vAllergenMLModal.vue?vue&type=script&lang=ts"
export * from "./vAllergenMLModal.vue?vue&type=script&lang=ts"
import style0 from "./vAllergenMLModal.vue?vue&type=style&index=0&id=4d3301a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3301a6",
  null
  
)

export default component.exports